<div class="d-md-flex d-none filter-section card m-sm-2 m-md-0 my-md-2 pt-1 px-2">
  <div class="d-flex justify-content-between mt-2 fs-8">
    <span class="fs-8">Showing {{ products.length }} Results</span>
    <ul class="d-flex gap-4 justify-content-between list-unstyled">
      <!--<div class="d-flex flex-col gap-2">
        <label class="price-label" for="price">Price Range</label>
        <input type="range" [value]="" id="price" name="price" min="5000" max="100000">
      </div>
      <li>Most Relevant</li>
      <li>Top Reviews</li>-->
      <li [class]="{'brand-color': selectedFilters?.price == 'desc'}" (click)="toggleFilter('price','desc', true)"><a role="button">Price High to Low</a></li>
      <li [class]="{'brand-color': selectedFilters?.price == 'asc'}"><a role="button" (click)="toggleFilter('price','asc', true)">Price Low to High</a></li>
    </ul>
  </div>
</div>
<div class="mobile-filter">
  <button type="button" class="button" (click)="sidebarFilter = true"><i class="pi pi-filter"></i></button>
</div>
<p-sidebar [(visible)]="sidebarFilter" position="right">
  <ng-template pTemplate="headless">
    <div class="card">
      <div class="card-header">
        <h3>Filter <h4 class="pi pi-times-circle float-end" (click)="sidebarFilter = false"></h4></h3>
      </div>
      <div class="card-body">
        <ul class="list-unstyled">
          <li *ngFor="let category of (filters | keyvalue)">
            <ul class="list-unstyled">
              <li class="fw-bold">{{category.key.replace('_',' ')}}</li>
              <li *ngFor="let option of category.value">
                <input type="checkbox" [value]="option" [checked]="selectedFilters[category.key]?.includes(option)" (change)="toggleFilter(category.key, option)"> {{option}}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="card-footer text-center">
        <button class="btn btn-outline-danger mt-3" (click)="applyFilters()">Apply Filters</button>
      </div>
    </div>
  </ng-template>
</p-sidebar>
